import {camelCase, snakeCase} from 'lodash';
import {requiredFieldsClientToServerMapping, requiredFieldsServerToClientMapping} from '../constants/requiredfields';

export const mapServerToClientRequiredFields = response =>
  response.reduce((acc, curr) => {
    const {fieldName: serverFieldName, ...rest} = curr;

    const rawFieldName = camelCase(serverFieldName);
    const fieldName = requiredFieldsServerToClientMapping[rawFieldName] ?? rawFieldName;

    return {...acc, [fieldName]: rest};
  }, {});

export const mapClientToServerRequiredFields = rawRequiredFields =>
  Object.entries(rawRequiredFields).map(([clientFieldName, {isRequired}]) => {
    const rawFieldName = requiredFieldsClientToServerMapping[clientFieldName] ?? clientFieldName;
    const fieldName = snakeCase(rawFieldName);

    return {
      fieldName,
      isRequired
    };
  });
